import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import WrapDetailPage from './pages/WrapDetailPage';

import FavoritesPage from './pages/FavoritesPage';
import ClaimsPage from './pages/ClaimsPage';


export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="*" element={<div style={{padding:16}}>404</div>} />

      <Route path="/wrap/:slug" element={<WrapDetailPage />} />
      <Route path="/favorites" element={<FavoritesPage />} />
      <Route path="/claims" element={<ClaimsPage />} />
    </Routes>
  );
}
